export var ControllerChatSender;
(function (ControllerChatSender) {
    ControllerChatSender[ControllerChatSender["User"] = 0] = "User";
    ControllerChatSender[ControllerChatSender["Controller"] = 1] = "Controller";
    ControllerChatSender[ControllerChatSender["Marketing"] = 2] = "Marketing";
})(ControllerChatSender || (ControllerChatSender = {}));
export var ControllerMessageType;
(function (ControllerMessageType) {
    ControllerMessageType[ControllerMessageType["Notification"] = 0] = "Notification";
    ControllerMessageType[ControllerMessageType["Message"] = 1] = "Message";
    ControllerMessageType[ControllerMessageType["Alarm"] = 2] = "Alarm";
    ControllerMessageType[ControllerMessageType["Warning"] = 3] = "Warning";
    ControllerMessageType[ControllerMessageType["Info"] = 4] = "Info";
})(ControllerMessageType || (ControllerMessageType = {}));
export var ControllerMessageSource;
(function (ControllerMessageSource) {
    ControllerMessageSource[ControllerMessageSource["Other"] = 0] = "Other";
    ControllerMessageSource[ControllerMessageSource["UserLoggedIn"] = 1] = "UserLoggedIn";
    ControllerMessageSource[ControllerMessageSource["UserLoggedOut"] = 2] = "UserLoggedOut";
    ControllerMessageSource[ControllerMessageSource["FoundNewDevice"] = 3] = "FoundNewDevice";
    ControllerMessageSource[ControllerMessageSource["DoorBellPress"] = 4] = "DoorBellPress";
    ControllerMessageSource[ControllerMessageSource["AddedNewDevice"] = 5] = "AddedNewDevice";
    ControllerMessageSource[ControllerMessageSource["RemovedDevice"] = 6] = "RemovedDevice";
    ControllerMessageSource[ControllerMessageSource["RegisteredNewUser"] = 7] = "RegisteredNewUser";
    ControllerMessageSource[ControllerMessageSource["GotAccessToTheInternet"] = 8] = "GotAccessToTheInternet";
    ControllerMessageSource[ControllerMessageSource["LostAccessToTheInternet"] = 9] = "LostAccessToTheInternet";
    ControllerMessageSource[ControllerMessageSource["RemovedUser"] = 10] = "RemovedUser";
    ControllerMessageSource[ControllerMessageSource["NetworkChanged"] = 11] = "NetworkChanged";
})(ControllerMessageSource || (ControllerMessageSource = {}));
export var ControllerMessageActions;
(function (ControllerMessageActions) {
    ControllerMessageActions["WeatherWidget"] = "WeatherWidget";
})(ControllerMessageActions || (ControllerMessageActions = {}));
//# sourceMappingURL=IControllerChat.js.map